function setCustomValidityPropAsParsedValue(inputOtp) {
    const attr = inputOtp.getAttribute("custom-validity");
    if (attr) {
        inputOtp.customValidity = JSON.parse(attr);
    }
}
export default () => {
    const inputOtpList = document.querySelectorAll("prism-input-otp");
    inputOtpList.forEach(setCustomValidityPropAsParsedValue);
};
